type AllocateResourceError = {
  duplicateAllocation: boolean;
};

const allocateResourceError: AllocateResourceError = {
  duplicateAllocation: false,
};

export type { AllocateResourceError };

export { allocateResourceError };
